import React, { useCallback, useMemo, useState } from 'react';
import { Card, Avatar, Modal, message } from 'antd';

import { resolveFileSrc } from '../../../../helpers/fileSrcResolver';
import env from '../../../../config/env';
import { FiEdit2, FiEye, FiTrash2 } from 'react-icons/fi';
import { ActionButton, RSSCardContent } from './styles';
import { formatDistance } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import RssFeedsApi from '../../../../services/sdks/rss-feeds';
import {
	RssFeedCategoriesIconsEnum,
	RssFeedCategoriesTranslationsEnum,
} from '../../../../enums/rss-feed-categories';
import { RssFeedRagionsTranslationsEnum } from '../../../../enums/rss-feed-regions';
import { RssFeedDetailsModal } from './rss-feed-details-modal';

export const RssFeedItem = ({ data, onDelete, onUpdate }) => {
	const [showDetails, setShowDetails] = useState(false);
	const coverSrc = useMemo(() => {
		return data?.coverImage
			? resolveFileSrc({
					fileName: data?.coverImage,
					folder: ['profile_pics'],
					bucket: env.miscS3Bucket,
			  })
			: null;
	}, [data]);

	const handleDelete = useCallback(async () => {
		try {
			await RssFeedsApi.deleteRssFeed(data._id);
			await onDelete();
			return message.success('Feed RSS excluído com sucesso');
		} catch (error) {
			console.error(error);
			message.error('Houve um erro, tente novamente');
		}
	}, [onDelete, data]);

	const Icon = useMemo(() => RssFeedCategoriesIconsEnum[data.category], [data]);

	return (
		<>
			<Card
				actions={[
					<ActionButton onClick={() => setShowDetails(true)}>
						<FiEye />
					</ActionButton>,
					<ActionButton onClick={() => onUpdate(data)}>
						<FiEdit2 />
					</ActionButton>,
					<ActionButton
						onClick={() => {
							Modal.confirm({
								title: `Apagar feed RSS?`,
								icon: 'exclamation-circle',
								content:
									'O feed será permanentemente excluído e isso não poderá ser revertido. Deseja continuar?',
								okText: 'Excluir Feed',
								onOk: handleDelete,
								okButtonProps: {
									icon: 'delete',
									type: 'danger',
								},
								cancelText: 'Cancelar',
								cancelButtonProps: {
									icon: 'close-circle',
								},
							});
						}}>
						<FiTrash2 />
					</ActionButton>,
				]}>
				<RSSCardContent>
					<header>
						<Avatar
							style={{ minWidth: '48px', minHeight: '48px', borderRadius: 12 }}
							src={coverSrc}
						/>
						<div>
							<h3>{data?.title}</h3>
							<small>
								Criado há{' '}
								{formatDistance(new Date(data.createdAt), new Date(), {
									locale: ptBR,
									addSuffix: false,
								})}
							</small>
						</div>
					</header>

					<div className='tags'>
						<span>
							<Icon />
							{RssFeedCategoriesTranslationsEnum[data.category]}
						</span>

						<span>Abrangência: {RssFeedRagionsTranslationsEnum[data.region]}</span>
					</div>

					<a href={data?.url} target='_blank' rel='noreferrer'>
						{data?.url}
					</a>
				</RSSCardContent>
			</Card>

			<RssFeedDetailsModal
				isVisible={showDetails}
				rssFeed={data}
				onClose={() => setShowDetails(false)}
			/>
		</>
	);
};
